import { OverlayShellConfig } from "../../../shared/overlay-shell/overlay.models";

export const NEW_ANNUAL_LEAVING_OVERLAY_CONFIG: OverlayShellConfig = {
  resizable: false,
  width: "auto",
  height: "auto",
};
